import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React, { useEffect } from "react";
import { StyledExchangerSelect } from "./styledExchanger";

const ExchangeConnectionsSelect = ({ exchange, connections, setExchange }) => {

  let currentConnection = exchange?.id;

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setExchange(prevState => ({ ...prevState, connectionId: data }));
  };

  useEffect(() => {
    if (connections?.length === 1) {
      setExchange(prevState => ({ ...prevState, connectionId: connections[0].id }));
    }
  }, [connections]);

  return (
    <StyledExchangerSelect mt="10">
      <FormControl>
        <InputLabel id={`exchange-connection-label`}>
          Select connection
        </InputLabel>
        {/* No need to change on Autocomplete component (exchanger) */}
        <Select
          labelId={`exchange-connection-label`}
          id={`exchange-connection-service`}
          value={connections?.length === 1 ? connections[0].id : currentConnection ?? ""}
          onChange={(e) => handleChangeSelect(e)}
          className="exchanger-select"
        >
          {connections.map((item, key) => (
            <MenuItem
              key={key}
              value={item.id}
            >
              <div className="exchanger-select__option">
                <span>{item.project.name} {item.name}</span>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyledExchangerSelect>
  );
};

export default ExchangeConnectionsSelect;